import { Component, OnInit, Inject } from '@angular/core';
import { DialogService } from '../../../shared/services/dialog.service';
import { MdInputModule, MdCheckboxModule, MdDialog, MdDialogRef, MD_DIALOG_DATA, MdCheckboxChange } from '@angular/material';
import { BaseService } from '../../../shared/services/base.service';
import { DialogComponent } from '../../../components/dialog/dialog.component';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { Page } from '../../../models/list/page.model';
import { ValidationService } from '../../../shared/services/validation.service';
import { ListMemberService } from './list-member.service';
import { PartyType } from '../../../models/consultation/cash-sale.model';

@Component({
    selector: 'add-member',
    templateUrl: 'add-member-popup.component.html',
    providers: [ListMemberService]
})

export class AddMemberPopupComponent implements OnInit {
    public addMemberForm: FormGroup;
    public page = new Page();
    public dataMessage = {
        emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
        totalMessage: AppMessages.list.total
    };
    public appConstants = AppConstants;
    public customClasses = AppConstants.table.footerClasses;
    public dataRow = [];
    public selected = [];
    public tempKeyword = '';
    // public allRowsSelected = false;
    constructor(public dialogService: DialogService,
        public formBuilder: FormBuilder,
        public dialogRef: MdDialogRef<AddMemberPopupComponent>,
        public utility: Utility,
        public listMemberService: ListMemberService,
        @Inject(MD_DIALOG_DATA) public data: { dataMember: Array<any>, bookingType: number }
    ) {
    }
    ngOnInit() {
        this.resetPage();
        this.createForm();
    }

    resetPage() {
        this.page = new Page();
        this.page.size = 5;
    }

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;
        this.searchPatients(this.addMemberForm.controls.name.value);
    }

    createForm() {
        this.addMemberForm = this.formBuilder.group({
            name: ['', [Validators.required]],
        });
    }

    onCloseDialog() {
        this.dialogRef.close();
    }

    onSearch() {
        if (this.addMemberForm.valid) {
            if (this.addMemberForm.controls.name.value.toLowerCase() !== this.tempKeyword.toLowerCase()) {
                this.tempKeyword = this.addMemberForm.controls.name.value;
                this.selected = [];
                this.resetPage();
            }
            this.searchPatients(this.addMemberForm.controls.name.value);
            // this.listMemberService.searchMember(this.addMemberForm.value).subscribe(
            //     result => {
            //         if (result) {
            //             const dataPatient = result.json();
            //             if (dataPatient === null || dataPatient === 'null') {
            //                 this.dialogService.openErrorDialog({ message: AppMessages.listMemberBooking.noPatient });
            //             } else {
            //                 [dataPatient].forEach(x => {
            //                     x.isSelected = false;
            //                 });
            //                 this.dataRow = [dataPatient];
            //             }

            //         }
            //     }
            // );

        }
    }

    searchPatients(keyword: string) {
        this.listMemberService.searchMember(keyword, this.page).subscribe(response => {
            if (response) {
                const dataPatient = response.json();
                this.dataRow = dataPatient['list'];
                if (dataPatient.totalCount === 0) {
                    this.dialogService.openErrorDialog({ message: AppMessages.listMemberBooking.noPatient });
                } else {
                    this.dataRow.forEach(x => {
                        x['isSelected'] = false;
                    });
                    this.page.totalElements = dataPatient.totalCount;
                    if (this.dataRow.length > 0 && this.selected.length > 0) {
                        this.dataRow.forEach(row => {
                            this.filterSelected(row);
                        });
                    }
                }
            }
        });
    }

    onSave() {
        if (this.dataRow.length > 0) {
            if (this.data.bookingType === PartyType.Individual && this.selected.length > 1) {
                this.dialogService.openErrorDialog({ message: AppMessages.listMemberBooking.errorAddPatientIndividual });
                return;
            }
            let isSame = false;
            if (this.data.dataMember) {
                if (this.data.dataMember['length'] > 0) {
                    const newArr = [];
                    this.data['dataMember'].forEach(element => {
                        const obj = this.selected.find(x => x.id === element['id']);
                        if (obj) {
                            newArr.push(obj.name);
                        }
                    });
                    if (newArr.length) {
                        isSame = true;
                        this.dialogService.openErrorDialog(
                            { message: Utility.stringFormat(AppMessages.listMemberBooking.duplicateMembers, [newArr.toString()]) });
                    }
                }
            }
            if (isSame === false) {
                this.dialogService.openSuccessDialog({ message: AppMessages.listMemberBooking.addMemberSuccess });
                this.dialogRef.close(this.selected);
            }
        }
    }

    onCheckboxChange(row, event: MdCheckboxChange) {
        row.isSelected = event.checked;
        const index = this.selected.findIndex(x => x.id === row.id);
        if (row.isSelected) {
            if (index < 0) {
                this.selected.push(row);
            }
        } else {
            if (index > -1) {
                this.selected.splice(index, 1);
            }
        }
    }

    filterSelected(row) {
        const index = this.selected.findIndex(x => x.id === row.id);
        if (index > -1) {
            row['isSelected'] = this.selected[index].isSelected;
        }
    }


}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/booking/list-member/add-member-popup.component.ts